import { useContext, useState } from "react";
import { StoreContext } from "../store/Store";
import { toBlob } from "html-to-image";
import { saveAs } from "file-saver";

const DownloadIcon = ({ color = "#646464", size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 16L12 8M12 16L8 12M12 16L16 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 17V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const SaveImage = ({ label, prefix, selectkeys, svgRef }) => {
  const [busy, setBusy] = useState(false);
  const [store] = useContext(StoreContext);
  const { controlPopupMenu } = store;

  const onClick = () => {
    setBusy(true);
    const name = `${prefix}_${selectkeys
      .map((item) => controlPopupMenu.selected[item])
      .reduce((a, b) => {
        return a + "_" + b;
      })}.png`;

    const node = svgRef.current;

    toBlob(node, { backgroundColor: "#FFFFFF" }).then(function (dataUrl) {
      saveAs(dataUrl, name);
      setBusy(false);
    });
  };
  
  return (
    <div
      title={label}
      style={{ cursor: busy ? "wait" : "pointer", display: "inline-flex" }}
      onClick={() => !busy && onClick()}
    >
      <DownloadIcon color={busy ? "#888" : "#646464"} size={15} />
    </div>
  );
};
